import moment from 'moment';
import { ClientTable } from 'vue-tables-2';
import { select } from '../shared/utils/dom';
import { formatBasicCurrency } from '../shared/utils/misc';

window.moment = moment;

export default function () {
  const el = select('[data-vue-app="usage-table"]');
  if (!el) {
    return;
  }

  Vue.use(ClientTable);
  const rowData = function (date) {
    return {
      'readDate': date, // eslint-disable-line quote-props
      'readMethod': 'Actual', // eslint-disable-line quote-props
      'averageTemp': '0.3', // eslint-disable-line quote-props
      'numberOfBillingDays': Math.floor(Math.random() * (31 - 29)) + 29, // eslint-disable-line quote-props
      'unitsUsed': '87.56', // eslint-disable-line quote-props
      'billAmount': 32.5, // eslint-disable-line quote-props
      'yearlyDeviation': '+0.3%', // eslint-disable-line quote-props
      'costPerDay': '1.4', // eslint-disable-line quote-props
    };
  };
  new Vue({ // eslint-disable-line no-new
    el,
    data() {
      return {
        columns: [
          'readDate',
          'readMethod',
          'averageTemp',
          'numberOfBillingDays',
          'unitsUsed',
          'yearlyDeviation',
          'billAmount',
          'costPerDay',
        ],
        tableData: window.VueTables.usageData || [
          rowData('2017-02-21T00:00:00Z'),
          rowData('2017-01-23T00:00:00Z'),
          rowData('2016-12-20T00:00:00Z'),
          rowData('2016-11-17T00:00:00Z'),
          rowData('2016-10-19T00:00:00Z'),
          rowData('2016-09-20T00:00:00Z'),
          rowData('2016-08-19T00:00:00Z'),
          rowData('2016-07-21T00:00:00Z'),
          rowData('2016-06-21T00:00:00Z'),
          rowData('2016-05-20T00:00:00Z'),
          rowData('2016-04-21T00:00:00Z'),
          rowData('2016-03-22T00:00:00Z'),
        ],
        options: {
          filterable: false,
          dateColumns: ['readDate'],
          dateFormat: 'MMM D, YYYY',
          toMomentFormat: 'YYYY-MM-DD',
          orderBy: {
            ascending: false,
            column: 'readDate',
          },
          headings: {
            'readDate': 'Date', // eslint-disable-line quote-props
            'readMethod': 'Type of Read', // eslint-disable-line quote-props
            'averageTemp': 'Avg. Temp.', // eslint-disable-line quote-props
            'numberOfBillingDays': 'Number of Days', // eslint-disable-line quote-props
            'unitsUsed': 'Units Used', // eslint-disable-line quote-props
            'yearlyDeviation': 'Yearly Usage + / -', // eslint-disable-line quote-props
            'billAmount': 'Bill Amount', // eslint-disable-line quote-props
            'costPerDay': 'Cost per Day', // eslint-disable-line quote-props
          },
          perPage: 10,
          templates: {
            readDate: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Date</div>
                <div class="table-cell-content">{(row.readDate)}</div>
              </div>
            ),
            readMethod: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Type of Read</div>
                <div class="table-cell-content">{(row.readMethod)}</div>
              </div>
            ),
            averageTemp: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Avg. Temp</div>
                <div class="table-cell-content">{(row.averageTemp)}</div>
              </div>
            ),
            numberOfBillingDays: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Number of Days</div>
                <div class="table-cell-content">{(row.numberOfBillingDays)}</div>
              </div>
            ),
            unitsUsed: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Units Used</div>
                <div class="table-cell-content">{(row.unitsUsed)}</div>
              </div>
            ),
            yearlyDeviation: (h, row) => {
              const numericalDeviation = parseFloat(row.yearlyDeviation * 100).toFixed(0);
              const formattedDeviation = numericalDeviation >= 0 ? `+${numericalDeviation}` : `${numericalDeviation}`;
              return (
                <div class="table-cell-wrapper">
                  <div class="table-cell-label">Yearly Usage + / -</div>
                  <div class="table-cell-content">{formattedDeviation}%</div>
                </div>
              );
            },
            billAmount: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Bill Amount</div>
                <div class="table-cell-content">{formatBasicCurrency(row.billAmount)}</div>
              </div>
            ),
            costPerDay: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Cost per Day</div>
                <div class="table-cell-content">{formatBasicCurrency(row.costPerDay)}</div>
              </div>
            ),
          },
        },
      };
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/usageTable.js